document.addEventListener('DOMContentLoaded', () => {
    $(document).on('click', '[data-download-report]', function () {
        console.log($(this));
        const link = $(this).closest('.sp-checker').find('#downloadReport [data-selected-option-value]').attr('data-selected-option-value').slice(2);
        window.open(link, '_blank');
    });

    if ($('[data-download-report]').length) {
        const select = new CustomSelect('.custom-select-js');
    }

    window.downloadReport = () => {
        fetch(window.location.href, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: 'download=true'
        })
            .then(res => res.text())
            .then(res => {
                $('.download .container').html(res);
                const select = new CustomSelect('.custom-select-js');
            });
    }

    // before drawSavedForm: filter beats saved form
    saveEntryFilterToForm('downloadReport');
})

function saveEntryFilterToForm(formId) {
    const form = document.querySelector(`form#${formId}`);
    if (!form || !bwCookieAllowed(formId, window.bwGranted)) return;

    // seeds hidden fields drawSavedForm would clear
    if (!localStorage.getItem(formId)) saveFormLocal(form);

    const iso = $.cookie('bw_country') || $('[data-auto-country]').attr('data-auto-country');
    let investor = $.cookie('bw_investor_type');
    const savedCategory = JSON.parse(localStorage.getItem(formId)).SP_INVESTOR_TYPE;
    const hasNonFilterCategory = savedCategory && Number(savedCategory[0]) > 2;

    if (investor === null || typeof investor === "undefined") {
        investor = 0;
    }
    if (iso && bwCookieAllowed('bw_form_country', window.bwGranted)) {
        saveFormLocal('', [formId, 'SP_COUNTRY', iso]);
    }
    if (!hasNonFilterCategory && bwCookieAllowed('bw_form_investor_type', window.bwGranted)) {
        saveFormLocal('', [formId, 'SP_INVESTOR_TYPE', Number(investor) + 1]);
    }
}
